import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/entities/Arbeitsbereich';

export class Abteilungsleiter {
  constructor({
    id,
    vorname,
    nachname,
    arbeitsbereich,
  }: {
    id: string;
    vorname: string;
    nachname: string;
    arbeitsbereich?: Arbeitsbereich;
  }) {
    this.id = id;
    this.vorname = vorname;
    this.nachname = nachname;
    this.arbeitsbereich = arbeitsbereich;
  }

  id: string;
  vorname: string;
  nachname: string;
  arbeitsbereich?: Arbeitsbereich;

  getName(): string {
    return this.vorname + ' ' + this.nachname;
  }

  getInitials(): string {
    return this.vorname[0] + this.nachname[0];
  }
}
